import Vue from 'vue';
import Vuex from 'vuex';
import ui from './ui';
import auth from '@/modules/auth/store/index.js';
import login from '@/modules/login/store/index.js';
import associates from '@/modules/associates/store/index.js';
import externals from '@/modules/externals/store/index.js';
import associatedTurns from '@/modules/associated-turns/store/index.js';
import externalTurns from '@/modules/external-turns/store/index.js';
import circles from '@/modules/circles/store/index.js';
import statistics from '@/modules/statistics/store/index.js';
import administrators from '@/modules/administrators/store/index.js';
import interactions from '@/modules/interactions/store/index.js';
import configurations from '@/modules/configurations/store/index.js';
import meetings from '@/modules/meetings/store/index.js';
import catalogs from '@/modules/catalogs/store/index.js';
import prospects from '@/modules/prospects/store/index.js';
import circleSimulator from '@/modules/circle-simulator/store/index.js';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    ui,
    auth,
    login,
    associates,
    externals,
    associatedTurns,
    externalTurns,
    circles,
    statistics,
    administrators,
    interactions,
    configurations,
    meetings,
    catalogs,
    prospects,
    circleSimulator,
  },
});
